<template>
  <div class="course-filter-box">
    <div class="course-filter-title">课程分类：</div>
    <div class="course-filter-content">
      <ul class="filter-list">
        <li
          class="filter-li"
          :class="{ 'current-type': currentType === item.id }"
          v-for="item in list1"
          :key="item.id"
          @click="changeType(item.id)"
        >
          {{ item.name }}
        </li>
      </ul>
      <ul v-show="list2.length > 0" class="filter-list">
        <li
          class="filter-li"
          :class="{ 'current-type': currentSubject === item.id }"
          v-for="item in list2"
          :key="item.id"
          @click="changeSubject(item.id)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import api from "../../assets/js/api";
export default {
  name: "ShopCenterAdminWebCourseFilter",
  props: {
    assignType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      list1: [],
      currentType: null,
      list2: [],
      currentSubject: null,
      allIds: [],
    };
  },
  watch: {
    assignType: {
      async handler(val) {
        // console.log("33333", val, this.list1);
        // 获取分类树
        await this.getCourseTree();
        // 如果传入的值不是null
        if (val) {
          // 根据名称找到对应的类别
          const type = this.list1.find((item) => item.name === val);
          // 选中其id
          if (type) {
            this.changeType(type.id);
          }
        } else {
          // 如果值为null 则选中第一个
          this.changeType(this.list1[0].id);
        }
      },
      immediate: true,
    },
  },

  mounted() {},

  methods: {
    // 获取课程分类树
    async getCourseTree() {
      const res = await this.$axios.get(api.creatCollege.getCourseCategory);
      this.list1 = res.result;
      this.list1.unshift({
        id: -1,
        name: "不限",
      });
      this.list1 = this.list1.map((item) => {
        item.id = Number(item.id);
        if (item.children && item.children.length > 0) {
          item.children.unshift({
            id: -2,
            name: "不限",
          });
          item.children = item.children.map((child) => {
            child.id = Number(child.id);
            return child;
          });
        }
        return item;
      });
      // this.currentType = this.list1[0].id;
      this.list2 = this.list1[0].children || [];
      // if (this.list2.length > 0) {
      //   this.currentSubject = this.list2[0].id;
      // } else {
      //   this.currentSubject = null;
      // }
      // this.$emit("change-filter", {
      //   currentType: this.currentType,
      //   currentSubject: this.currentSubject,
      // });
    },
    changeType(id) {
      if (this.currentType == id) return;
      this.currentType = id;
      this.list2 = this.list1.find((item) => item.id === id).children || [];
      if (this.list2.length > 0) {
        this.allIds = [];
        this.list2.forEach((item) => {
          if (item.id !== -2) {
            this.allIds.push(item.id);
          }
        });
        this.currentSubject = this.list2[0].id;
      } else {
        this.currentSubject = null;
      }
      const filter = {
        currentType: this.currentType,
        currentSubject: this.currentSubject,
      };
      if (filter.currentSubject && filter.currentSubject !== -2) {
        filter.currentSubject = [this.currentSubject];
      } else if (filter.currentSubject == -2) {
        filter.currentSubject = this.allIds;
      }
      // console.log("切换分类filter----", filter);
      this.$emit("change-filter", filter);
    },
    changeSubject(id) {
      if (this.currentSubject == id) return;
      this.currentSubject = id;
      const filter = {
        currentType: this.currentType,
        currentSubject: this.currentSubject,
      };
      if (filter.currentSubject == -2) {
        filter.currentSubject = this.allIds;
      } else {
        filter.currentSubject = [this.currentSubject];
      }
      // console.log("切换科目filter----", filter);
      this.$emit("change-filter", filter);
    },
  },
};
</script>

<style lang="scss" scoped>
.course-filter-box {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 25px 0 20px 40px;
  border-bottom: 1px solid #eaeaea;
  .course-filter-title {
    margin-right: 10px;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }
  .course-filter-content {
    .filter-list {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: 15px;
      &:first-child {
        margin-top: 0;
      }
      .filter-li {
        padding: 0 10px;
        margin-left: 20px;
        color: #1a1a1a;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        cursor: pointer;
        user-select: none;
        &:first-child {
          margin-left: 0;
        }
        &:hover {
          color: #6384f7;
        }
      }
      .current-type {
        color: #6384f7;
        border-radius: 4px;
        background: rgba(99, 132, 247, 0.15);
      }
    }
  }
}
</style>
